// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1540":"727c550f","1550":"727c550f","2840":"727c550f","3784":"727c550f","4588":"727c550f","4969":"727c550f","8290":"727c550f","8677":"727c550f"}[chunkId] + ".chunk.css";
};